module.exports = __webpack_public_path__ + "media/images/french_hockey-79c0b655.jpg";